import React from 'react';
import { Typography, TypographyOwnProps } from '@mui/material';

import { useDataTableStyles } from './useDataTableStyles';

interface DataTableItemProps {
  value: string | JSX.Element;
  longText?: boolean;
  variant?: TypographyOwnProps['variant'];
  className?: string;
}

export const DataTableItem = ({
  value,
  longText,
  variant = 'caption',
  className,
}: DataTableItemProps) => {
  const { classes, cx } = useDataTableStyles();

  const isElement = React.isValidElement(value);

  if (isElement) {
    const element = value as React.ReactElement<{ className?: string }>;

    return React.cloneElement(element, {
      className: cx(element.props?.className, className),
    });
  }

  return (
    <Typography
      className={cx(className, { [classes.longText]: longText })}
      variant={variant}
    >
      {value}
    </Typography>
  );
};
